<template>
    <div class="md-testimonial-logo source-logo-container" v-if="info.src">
        <site-img
            class="source-logo"
            :width="width"
            :height="height"
            :alt="$t(info.alt)"
            :src="(isDarkTheme ? info.lightSrc : info.src) || info.src"
        />
    </div>
</template>

<script>
import { REVIEW_LOGO_ALT } from './constants';
export default {
    i18next: {
        ns: 'md-testimonial'
    },
    props: {
        isDarkTheme: {
            type: Boolean,
            default: false
        },
        sourceType: {
            type: Number
        },
        width: {
            type: [String, Number]
        },
        height: {
            type: [String, Number],
            default: 18
        }
    },
    computed: {
        info() {
            return REVIEW_LOGO_ALT[this.sourceType] || {};
        }
    }
};
</script>
<style lang="scss">
.md-testimonial-logo.source-logo-container {
    .source-logo {
        vertical-align: middle;
    }
}
</style>
